import { useMemo } from 'react';
import { baseAuthStyles } from '../base/authStyles';
import { customerAuthStyles } from '../overrides/customer/authStyles';

export type UserRole = 'customer' | 'admin' | 'translator' | 'manager' | 'default';

export const useAuthStyles = (role?: UserRole) => {
  return useMemo(() => {
    const userRole = role || getUserRole();

    switch (userRole) {
      case 'customer':
        return customerAuthStyles;
      default:
        return baseAuthStyles;
    }
  }, [role]);
};

const getUserRole = (): UserRole => {
  try {
    const userDetails = localStorage.getItem('user_details');
    if (userDetails) {
      const user = JSON.parse(userDetails);
      const roleId = user.user_role_type_id;

      switch (roleId) {
        case '1':
          return 'customer';
        case '4':
        case '7':
          return 'admin';
        case '6':
          return 'translator';
        case '3':
          return 'manager';
        default:
          return 'default';
      }
    }
  } catch (error) {
    console.error('Error getting user role:', error);
  }

  return 'default';
};

export default useAuthStyles;
